import { render, staticRenderFns } from "./VideoFeedbacks.vue?vue&type=template&id=599f2a84&scoped=true&"
import script from "./VideoFeedbacks.vue?vue&type=script&lang=js&"
export * from "./VideoFeedbacks.vue?vue&type=script&lang=js&"
import style0 from "./VideoFeedbacks.vue?vue&type=style&index=0&id=599f2a84&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599f2a84",
  null
  
)

export default component.exports